import "./play.e2c56a15.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5652"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5652"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
let $f075168bfc01f057$var$videoDetails = null;
/**
 * Load and initialize tracking.
 * @param {{ id: string, language: string, state: string }} details video details used for tracking
 */ function $f075168bfc01f057$var$init({ id: id, language: language, event_state: event_state }) {
    return new Promise((res)=>{
        const url = "https://unfccc-analytics.azureedge.net";
        if (!url) res();
        else {
            window._paq = window._paq || [];
            window._paq.push([
                "setTrackerUrl",
                `${url}/matomo.php`
            ]);
            window._paq.push([
                "setSiteId",
                "1"
            ]);
            const g = document.createElement("script");
            const s = document.getElementsByTagName("script")[0];
            g.onload = ()=>{
                $f075168bfc01f057$var$videoDetails = {
                    id: id,
                    language: language,
                    event_state: event_state
                };
                res();
            };
            g.onerror = ()=>res();
            g.type = "text/javascript";
            g.async = true;
            g.src = `${url}/matomo.js`;
            s.parentNode.insertBefore(g, s);
        }
    });
}
function $f075168bfc01f057$var$sendViewEvent() {
    if (!$f075168bfc01f057$var$videoDetails) return;
    window._paq.push([
        "setCustomUrl",
        `/${$f075168bfc01f057$var$videoDetails.id} >> ${$f075168bfc01f057$var$videoDetails.event_state}`
    ]);
    window._paq.push([
        "setDocumentTitle",
        JSON.stringify($f075168bfc01f057$var$videoDetails)
    ]);
    window._paq.push([
        "trackPageView"
    ]);
}
/**
 * @param {string} clickName
 */ function $f075168bfc01f057$var$sendClickEvent(clickName) {
    if (!$f075168bfc01f057$var$videoDetails) return;
    const eventName = `${$f075168bfc01f057$var$videoDetails.id} >> ${$f075168bfc01f057$var$videoDetails.event_state}`;
    window._paq.push([
        "trackEvent",
        clickName,
        "click",
        eventName
    ]);
}
/**
 * @param {string} type
 */ function $f075168bfc01f057$var$sendMediaEvent(type) {
    if (!$f075168bfc01f057$var$videoDetails) return;
    const eventAction = `${$f075168bfc01f057$var$videoDetails.id} >> ${$f075168bfc01f057$var$videoDetails.language} >> ${$f075168bfc01f057$var$videoDetails.event_state}`;
    const eventName = `${eventAction} >> ${type}`;
    window._paq.push([
        "trackEvent",
        eventAction,
        "media",
        eventName
    ]);
}
function $f075168bfc01f057$var$sendPlayMediaEvent() {
    $f075168bfc01f057$var$sendMediaEvent("play");
}
/**
 * @param {string} language
 */ function $f075168bfc01f057$var$updateLanguage(language) {
    if (!$f075168bfc01f057$var$videoDetails) return;
    $f075168bfc01f057$var$videoDetails.language = language;
}
var $f075168bfc01f057$export$2e2bcd8739ae039 = {
    init: $f075168bfc01f057$var$init,
    sendViewEvent: $f075168bfc01f057$var$sendViewEvent,
    sendClickEvent: $f075168bfc01f057$var$sendClickEvent,
    sendMediaEvent: $f075168bfc01f057$var$sendMediaEvent,
    sendPlayMediaEvent: $f075168bfc01f057$var$sendPlayMediaEvent,
    updateLanguage: $f075168bfc01f057$var$updateLanguage
};



var $azCq4 = parcelRequire("azCq4");
/*! @name videojs-overlay @version 4.0.0 @license Apache-2.0 */ 
var $azCq4 = parcelRequire("azCq4");

var $9EQK2 = parcelRequire("9EQK2");
const $876a6eca12cb27ca$var$initOverlayComponent = (videojs)=>{
    const Component = videojs.getComponent('Component');
    const dom = videojs.dom || videojs;
    /**
   * Whether the value is a `Number`.
   *
   * Both `Infinity` and `-Infinity` are accepted, but `NaN` is not.
   *
   * @param  {Number} n
   * @return {Boolean}
   */ /* eslint-disable no-self-compare */ const isNumber = (n)=>typeof n === 'number' && n === n;
    /* eslint-enable no-self-compare */ /**
   * Whether a value is a string with no whitespace.
   *
   * @param  {string} s
   * @return {boolean}
   */ const hasNoWhitespace = (s)=>typeof s === 'string' && /^\S+$/.test(s);
    /**
   * Overlay component.
   *
   * @class   Overlay
   * @extends {videojs.Component}
   */ class Overlay extends Component {
        constructor(player, options){
            super(player, options);
            [
                'start',
                'end'
            ].forEach((key)=>{
                const value = this.options_[key];
                if (isNumber(value)) this[key + 'Event_'] = 'timeupdate';
                else if (hasNoWhitespace(value)) this[key + 'Event_'] = value;
                else if (key === 'start') throw new Error('invalid "start" option; expected number or string');
            });
            // video.js does not like components with multiple instances binding
            // events to the player because it tracks them at the player level,
            // not at the level of the object doing the binding. This could also be
            // solved with Function.prototype.bind (but not videojs.bind because of
            // its GUID magic), but the anonymous function approach avoids any issues
            // caused by crappy libraries clobbering Function.prototype.bind.
            // - https://github.com/videojs/video.js/issues/3097
            [
                'endListener_',
                'rewindListener_',
                'startListener_'
            ].forEach((name)=>{
                this[name] = (e)=>Overlay.prototype[name].call(this, e);
            });
            // If the start event is a timeupdate, we need to watch for rewinds (i.e.,
            // when the user seeks backward).
            if (this.startEvent_ === 'timeupdate') this.on(player, 'timeupdate', this.rewindListener_);
            this.debug(`created, listening to "${this.startEvent_}" for "start" and "${this.endEvent_ || 'nothing'}" for "end"`);
            this.hide();
        }
        createEl() {
            const options = this.options_;
            const content = options.content;
            const background = options.showBackground ? 'vjs-overlay-background' : 'vjs-overlay-no-background';
            const el = dom.createEl('div', {
                className: `
          vjs-overlay
          vjs-overlay-${options.align}
          ${options.class}
          ${background}
          vjs-hidden
        `
            });
            if (typeof content === 'string') el.innerHTML = content;
            else if (content instanceof (0, (/*@__PURE__*/$parcel$interopDefault($9EQK2))).DocumentFragment) el.appendChild(content);
            else dom.appendContent(el, content);
            return el;
        }
        /**
     * Logs debug errors
     *
     * @param  {...[type]} args [description]
     * @return {[type]}         [description]
     */ debug(...args) {
            if (!this.options_.debug) return;
            const log = videojs.log;
            let fn = log;
            // Support `videojs.log.foo` calls.
            if (log.hasOwnProperty(args[0]) && typeof log[args[0]] === 'function') fn = log[args.shift()];
            fn(...[
                `overlay#${this.id()}: `,
                ...args
            ]);
        }
        /**
     * Overrides the inherited method to perform some event binding
     *
     * @return {Overlay}
     */ hide() {
            super.hide();
            this.debug('hidden');
            this.debug(`bound \`startListener_\` to "${this.startEvent_}"`);
            // Overlays without an "end" are valid.
            if (this.endEvent_) {
                this.debug(`unbound \`endListener_\` from "${this.endEvent_}"`);
                this.off(this.player(), this.endEvent_, this.endListener_);
            }
            this.on(this.player(), this.startEvent_, this.startListener_);
            return this;
        }
        /**
     * Determine whether or not the overlay should hide.
     *
     * @param  {number} time
     *         The current time reported by the player.
     * @param  {string} type
     *         An event type.
     * @return {boolean}
     */ shouldHide_(time, type) {
            const end = this.options_.end;
            return isNumber(end) ? time >= end : end === type;
        }
        /**
     * Overrides the inherited method to perform some event binding
     *
     * @return {Overlay}
     */ show() {
            super.show();
            this.off(this.player(), this.startEvent_, this.startListener_);
            this.debug('shown');
            this.debug(`unbound \`startListener_\` from "${this.startEvent_}"`);
            // Overlays without an "end" are valid.
            if (this.endEvent_) {
                this.debug(`bound \`endListener_\` to "${this.endEvent_}"`);
                this.on(this.player(), this.endEvent_, this.endListener_);
            }
            return this;
        }
        /**
     * Determine whether or not the overlay should show.
     *
     * @param  {number} time
     *         The current time reported by the player.
     * @param  {string} type
     *         An event type.
     * @return {boolean}
     */ shouldShow_(time, type) {
            const start = this.options_.start;
            const end = this.options_.end;
            if (isNumber(start)) {
                if (isNumber(end)) return time >= start && time < end;
                else if (!this.hasShownSinceSeek_) {
                    this.hasShownSinceSeek_ = true;
                    return time >= start;
                }
                // In this case, the start is a number and the end is a string, but
                // the overlay has shown since the last seek. This means that we need
                // to be sure we aren't re-showing it at a later time than it is
                // scheduled to appear.
                return Math.floor(time) === start;
            }
            return start === type;
        }
        /**
     * Event listener that can trigger the overlay to show.
     *
     * @param  {Event} e
     */ startListener_(e) {
            const time = this.player().currentTime();
            if (this.shouldShow_(time, e.type)) this.show();
        }
        /**
     * Event listener that can trigger the overlay to show.
     *
     * @param  {Event} e
     */ endListener_(e) {
            const time = this.player().currentTime();
            if (this.shouldHide_(time, e.type)) this.hide();
        }
        /**
     * Event listener that can looks for rewinds - that is, backward seeks
     * and may hide the overlay as needed.
     *
     * @param  {Event} e
     */ rewindListener_(e) {
            const time = this.player().currentTime();
            const previous = this.previousTime_;
            const start = this.options_.start;
            const end = this.options_.end;
            // Did we seek backward?
            if (time < previous) {
                this.debug('rewind detected');
                // The overlay remains visible if two conditions are met: the end value
                // MUST be an integer and the the current time indicates that the
                // overlay should NOT be visible.
                if (isNumber(end) && !this.shouldShow_(time)) {
                    this.debug(`hiding; ${end} is an integer and overlay should not show at this time`);
                    this.hasShownSinceSeek_ = false;
                    this.hide();
                // If the end value is an event name, we cannot reliably decide if the
                // overlay should still be displayed based solely on time; so, we can
                // only queue it up for showing if the seek took us to a point before
                // the start time.
                } else if (hasNoWhitespace(end) && time < start) {
                    this.debug(`hiding; show point (${start}) is before now (${time}) and end point (${end}) is an event`);
                    this.hasShownSinceSeek_ = false;
                    this.hide();
                }
            }
            this.previousTime_ = time;
        }
    }
    videojs.registerComponent('Overlay', Overlay);
    return Overlay;
};
const $876a6eca12cb27ca$var$Plugin = (0, $azCq4.default).getPlugin('plugin');
const $876a6eca12cb27ca$var$defaults = {
    align: 'top-left',
    class: '',
    content: 'This overlay will show up while the video is playing',
    debug: false,
    showBackground: true,
    attachToControlBar: false,
    overlays: [
        {
            start: 'playing',
            end: 'paused'
        }
    ]
};
/**
 * A plugin for handling overlays in the Brightcove Player.
 */ class $876a6eca12cb27ca$export$2e2bcd8739ae039 extends $876a6eca12cb27ca$var$Plugin {
    /**
   * Create an Overlay Plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An options object.
   */ constructor(player, options){
        super(player);
        this.reset(options);
    }
    /**
   * Adds one or more items to the existing list of overlays.
   *
   * @param {Object|Array} item
   *        An item (or an array of items) to be added as overlay/s
   *
   * @return {Array[Overlay]}
   *         The array of overlay objects that were added
   */ add(item) {
        if (!Array.isArray(item)) item = [
            item
        ];
        const addedOverlays = this.mapOverlays_(item);
        this.player.overlays_ = this.player.overlays_.concat(addedOverlays);
        return addedOverlays;
    }
    /**
   *
   * @param {Overlay} item
   *        An item to be removed from the array of overlays
   *
   * @throws {Error}
   *        Item to remove must be present in the array of overlays
   *
   */ remove(item) {
        const index = this.player.overlays_.indexOf(item);
        if (index !== -1) {
            item.el().parentNode.removeChild(item.el());
            this.player.overlays_.splice(index, 1);
        } else this.player.log.warn('overlay does not exist and cannot be removed');
    }
    /**
   * Gets the array of overlays used for the current video
   *
   * @return The array of overlay objects currently used by the plugin
   */ get() {
        return this.player.overlays_;
    }
    /**
   * Updates the overlay options
   *
   * @param  {Object} [options]
   *         An options object.
   */ reset(options) {
        this.clearOverlays_();
        // Use merge function based on video.js version.
        const merge = (0, $azCq4.default).obj && (0, $azCq4.default).obj.merge || (0, $azCq4.default).mergeOptions;
        this.options = merge($876a6eca12cb27ca$var$defaults, options);
        const overlays = this.options.overlays;
        // We don't want to keep the original array of overlay options around
        // because it doesn't make sense to pass it to each Overlay component.
        delete this.options.overlays;
        this.player.overlays_ = this.mapOverlays_(overlays);
    }
    /**
   * Disposes the plugin
   */ dispose() {
        this.clearOverlays_();
        delete this.player.overlays_;
        super.dispose();
    }
    clearOverlays_() {
        // Remove child components
        if (Array.isArray(this.player.overlays_)) this.player.overlays_.forEach((overlay)=>{
            this.player.removeChild(overlay);
            if (this.player.controlBar) this.player.controlBar.removeChild(overlay);
        });
    }
    mapOverlays_(items) {
        return items.map((o)=>{
            const mergeOptions = (0, $azCq4.default).mergeOptions(this.options, o);
            const attachToControlBar = typeof mergeOptions.attachToControlBar === 'string' || mergeOptions.attachToControlBar === true;
            if (!this.player.controls() || !this.player.controlBar) return this.player.addChild('overlay', mergeOptions);
            if (attachToControlBar && mergeOptions.align.indexOf('bottom') !== -1) {
                let referenceChild = this.player.controlBar.children()[0];
                if (this.player.controlBar.getChild(mergeOptions.attachToControlBar) !== undefined) referenceChild = this.player.controlBar.getChild(mergeOptions.attachToControlBar);
                if (referenceChild) {
                    const referenceChildIndex = this.player.controlBar.children().indexOf(referenceChild);
                    const controlBarChild = this.player.controlBar.addChild('overlay', mergeOptions, referenceChildIndex);
                    return controlBarChild;
                }
            }
            const playerChild = this.player.addChild('overlay', mergeOptions);
            this.player.el().insertBefore(playerChild.el(), this.player.controlBar.el());
            return playerChild;
        });
    }
}
var $876a6eca12cb27ca$var$version = "4.0.0";
$876a6eca12cb27ca$var$initOverlayComponent((0, $azCq4.default));
$876a6eca12cb27ca$export$2e2bcd8739ae039.VERSION = $876a6eca12cb27ca$var$version;
(0, $azCq4.default).registerPlugin('overlay', $876a6eca12cb27ca$export$2e2bcd8739ae039);



var $azCq4 = parcelRequire("azCq4");
const $6e3e9e2718a47ca8$var$Plugin = (0, $azCq4.default).getPlugin("plugin");
const $6e3e9e2718a47ca8$var$Button = (0, $azCq4.default).getComponent("Button");
class $6e3e9e2718a47ca8$var$UnmuteButton extends $6e3e9e2718a47ca8$var$Button {
    constructor(player, options){
        super(player, options);
        this.controlText(player.localize("Unmute"));
        player.one("volumechange", ()=>{
            player.removeClass("vjs-muted-autoplay");
            this.dispose();
        });
    }
    buildCSSClass() {
        return `vjs-unmute-button ${super.buildCSSClass()}`;
    }
    handleClick() {
        this.player().muted(false);
    }
}
class $6e3e9e2718a47ca8$export$57725667936edac0 extends $6e3e9e2718a47ca8$var$Plugin {
    constructor(player, options){
        super(player, options);
        player.on("ready", ()=>{
            if (player.muted() && player.autoplay()) {
                player.addChild("UnmuteButton");
                player.addClass("vjs-muted-autoplay");
            }
        });
    }
}
(0, $azCq4.default).registerComponent("UnmuteButton", $6e3e9e2718a47ca8$var$UnmuteButton);
(0, $azCq4.default).registerPlugin("unmute", $6e3e9e2718a47ca8$export$57725667936edac0);



var $60top = parcelRequire("60top");
const $b7eebcf7cc31128e$export$90f91d650d69eb98 = {
    poster: {
        class: "poster-overlay",
        content: "",
        start: "showPoster",
        end: "hidePoster"
    },
    beforeStartNotice: {
        class: "notice-overlay",
        content: "This webcast will start shortly.<br>Thank you for your patience.",
        align: "bottom",
        start: "showNotice",
        end: "hideNotice"
    },
    afterStopNotice: {
        class: "notice-overlay",
        content: "The webcast is over or not available.",
        align: "bottom",
        start: "showNotice",
        end: "hideNotice"
    }
};


const $669a8b47d2405041$var$playUrl = "https://unfccc-func-cons-bmcufehze5g2fsh4.z01.azurefd.net/api/play";
const $669a8b47d2405041$var$maxRetryDelay = 10;
const $669a8b47d2405041$var$maxFunctionRetry = 5;
const $669a8b47d2405041$var$forceReloadBufferEmptyMs = 20000;
/** @type {videojs.Player} */ let $669a8b47d2405041$var$player;
let $669a8b47d2405041$var$tracks;
let $669a8b47d2405041$var$context;
let $669a8b47d2405041$var$errorCount = 0;
let $669a8b47d2405041$var$functionErrorCount = 0;
let $669a8b47d2405041$var$functionMaxRetryReached = false;
let $669a8b47d2405041$var$refreshTimeout = null;
let $669a8b47d2405041$var$bufferEmptyTimeout = null;
let $669a8b47d2405041$var$wakeLock = null;
let $669a8b47d2405041$var$wasMuted = null;
/**
 * VideoJS's XHR request intercepter. We use it to patch outgoing requests with the refreshed streaming tokens.
 * @param {*} options videojs xhr options
 * @returns patched options
 */ // function globalXhrRequestHook(options) {
//   const stream = getCurrentStream();
//   const url = new URL(options.uri);
//   const search = new URL(stream.source.src).search.substring(1);
//   if (url.pathname.endsWith(".m3u8") || url.pathname.endsWith(".ts")) {
//     url.search = `?${search}`;
//   }
//   options.uri = url.toString();
//   return options;
// }
// videojs.Vhs.xhr.onRequest(globalXhrRequestHook);
/**
 * Function to calc a randomized but good time to refresh the streaming token
 * @param {number} expires ms until the token expires
 * @returns ms until nice time to refresh
 */ function $669a8b47d2405041$var$niceRefreshTime(expires) {
    const now = Date.now();
    const halfDuration = expires * 0.5;
    const half = now + halfDuration;
    const last = now + expires * 0.9;
    return Math.floor(halfDuration + (last - half) * Math.random());
}
/**
 * Every now and then the play function errors out under high load.
 * Very very low fail rate, so let's just retry.
 */ async function $669a8b47d2405041$var$handleFatalPlayFunctionError(jwt) {
    if ($669a8b47d2405041$var$functionErrorCount >= $669a8b47d2405041$var$maxFunctionRetry) {
        $669a8b47d2405041$var$functionMaxRetryReached = true;
        throw new Error("ERR_MAX_FUNCTION_RETRIES_REACHED");
    }
    // wait a bit
    await new Promise((resolve)=>setTimeout(()=>resolve(), $669a8b47d2405041$var$functionErrorCount * 1000));
    $669a8b47d2405041$var$functionErrorCount++;
    // retry
    return $669a8b47d2405041$var$fetchStreams(jwt);
}
/**
 * Fetches the streaming context (incl. token) and keeps it up2date.
 * @param {string} jwt initial or refresh token for play endpoint
 * @returns {void} when inital request is done
 */ async function $669a8b47d2405041$var$fetchStreams(jwt) {
    let response;
    try {
        response = await window.fetch($669a8b47d2405041$var$playUrl, {
            method: "post",
            body: JSON.stringify({
                jwt: jwt
            })
        });
    } catch (err) {
        console.warn('Error fetching play context:', err);
        return $669a8b47d2405041$var$handleFatalPlayFunctionError(jwt);
    }
    if (response.status === 500) return $669a8b47d2405041$var$handleFatalPlayFunctionError(jwt);
    else $669a8b47d2405041$var$functionErrorCount = 0;
    $669a8b47d2405041$var$context = await response.json();
    if (!response.ok) throw $669a8b47d2405041$var$context;
    if ($669a8b47d2405041$var$refreshTimeout) clearTimeout($669a8b47d2405041$var$refreshTimeout);
    $669a8b47d2405041$var$refreshTimeout = setTimeout(()=>$669a8b47d2405041$var$fetchStreams($669a8b47d2405041$var$context.refresh), $669a8b47d2405041$var$niceRefreshTime($669a8b47d2405041$var$context.expires * 1000));
}
/**
 * Retrieve the current stream based on the chosen audio track
 * @returns {{ source: { src: string, type: string }, track: { enabled: boolean, id: string, kind: string, label: string }}}
 */ function $669a8b47d2405041$var$getCurrentStream() {
    const track = Array.from($669a8b47d2405041$var$tracks).find((t)=>t.enabled);
    return $669a8b47d2405041$var$context.streams.find((stream)=>stream.track.id === track.id);
}
/**
 * Override audio tracks explicitly and seal the AudioTrackList
 */ function $669a8b47d2405041$var$setupAudioTracks() {
    Array.from($669a8b47d2405041$var$tracks).forEach((t)=>$669a8b47d2405041$var$tracks.removeTrack(t));
    $669a8b47d2405041$var$context.streams.forEach((stream, idx)=>{
        $669a8b47d2405041$var$tracks.addTrack(new (0, $azCq4.default).AudioTrack(stream.track));
    });
    // seal tracklist the sneaky way: prevent videojs to change it on metadata load
    $669a8b47d2405041$var$tracks.addTrack = ()=>{};
    $669a8b47d2405041$var$tracks.removeTrack = ()=>{};
}
/**
 * Track has been switched, start play it
 * */ function $669a8b47d2405041$var$trackChanged() {
    const time = $669a8b47d2405041$var$player.currentTime();
    const { source: source, track: track } = $669a8b47d2405041$var$getCurrentStream();
    (0, $f075168bfc01f057$export$2e2bcd8739ae039).updateLanguage(track.label);
    $669a8b47d2405041$var$player.src(source);
    $669a8b47d2405041$var$player.trigger("hideNotice");
    const playMaybePromise = $669a8b47d2405041$var$player.play();
    if (playMaybePromise !== undefined) playMaybePromise.catch((error)=>{
        console.warn("Play promise rejected:", error);
        setTimeout(()=>$669a8b47d2405041$var$player.play(), 1000);
    });
    // just for vod, seek to previous time
    if (source.src.includes("/mp4:/")) $669a8b47d2405041$var$player.one("play", ()=>$669a8b47d2405041$var$player.currentTime(time));
}
/**
 * Track has been switched, trigger appropriate analytic events
 * */ function $669a8b47d2405041$var$trackTrackChange() {
    const { track: track } = $669a8b47d2405041$var$getCurrentStream();
    (0, $f075168bfc01f057$export$2e2bcd8739ae039).sendClickEvent(track.label);
    (0, $f075168bfc01f057$export$2e2bcd8739ae039).sendViewEvent();
    $669a8b47d2405041$var$player.off("play", (0, $f075168bfc01f057$export$2e2bcd8739ae039).sendPlayMediaEvent);
    $669a8b47d2405041$var$player.one("play", (0, $f075168bfc01f057$export$2e2bcd8739ae039).sendPlayMediaEvent);
}
/**
 * Stream that played well seems to be not available anymore
 */ function $669a8b47d2405041$var$playingStreamBrokeAway() {
    if ($669a8b47d2405041$var$functionMaxRetryReached) return $669a8b47d2405041$var$player.error("ERR_MAX_FUNCTION_RETRIES_REACHED");
    $669a8b47d2405041$var$player.trigger("showNotice");
    // stream switched the server
    if (new URL($669a8b47d2405041$var$player.src()).hostname !== new URL($669a8b47d2405041$var$getCurrentStream().source.src).hostname) $669a8b47d2405041$var$trackChanged(); // follow it
    else {
        console.log("Stream seems to be stuck, bufferEmptyTimeout:", $669a8b47d2405041$var$bufferEmptyTimeout);
        if (!$669a8b47d2405041$var$bufferEmptyTimeout) $669a8b47d2405041$var$bufferEmptyTimeout = setTimeout(()=>{
            $669a8b47d2405041$var$wasMuted = $669a8b47d2405041$var$player.muted();
            console.log('Buffering is taking too long, reloading the stream.');
            $669a8b47d2405041$var$bufferEmptyTimeout = null;
            $669a8b47d2405041$var$trackChanged();
        }, $669a8b47d2405041$var$forceReloadBufferEmptyMs); // we give it 15s to recover before reloading
    }
}
/**
 * Verify or fail. On success kickstart player.
 */ async function $669a8b47d2405041$var$init() {
    const jwtParam = new URL(window.location.href).searchParams.get("jwt");
    try {
        await $669a8b47d2405041$var$fetchStreams(jwtParam);
    } catch (error) {
        $669a8b47d2405041$var$player = (0, $azCq4.default)("player");
        $669a8b47d2405041$var$player.error(error.code || error.message || error);
        return;
    }
    try {
        const jwt = (0, $60top.jwtDecode)(jwtParam);
        await (0, $f075168bfc01f057$export$2e2bcd8739ae039).init({
            id: jwt.stream,
            language: $669a8b47d2405041$var$context.streams.find((stream)=>stream.track.kind === "main").track.label,
            event_state: jwt.aud === "liveplayer" ? "live" : "ondemand"
        });
    } catch (error) {
        console.log("Failed to init analytics", error);
    }
    let config = {
        play: {}
    };
    try {
        config = await (await fetch('/play/config.json')).json();
    } catch (error) {
        console.log("Failed to load config", error);
    }
    if (config.play.poster) document.documentElement.style.setProperty("--poster", `url(${config.play.poster})`);
    if (config.play.highlightColor) document.documentElement.style.setProperty("--highlight-color", config.play.highlightColor);
    $669a8b47d2405041$var$player = (0, $azCq4.default)("player", {
        controls: true,
        muted: true,
        autoplay: "muted",
        html5: {
            nativeAudioTracks: false,
            nativeVideoTracks: false
        }
    });
    // Set unmute plugin
    $669a8b47d2405041$var$player.unmute();
    // Set overlay plugin for streams that are not available yet
    $669a8b47d2405041$var$player.overlay({
        overlays: [
            (0, $b7eebcf7cc31128e$export$90f91d650d69eb98).poster,
            {
                ...(0, $b7eebcf7cc31128e$export$90f91d650d69eb98).beforeStartNotice,
                content: config.play.beforeStartNotice || (0, $b7eebcf7cc31128e$export$90f91d650d69eb98).beforeStartNotice.content
            }
        ]
    });
    $669a8b47d2405041$var$player.trigger("showPoster");
    $669a8b47d2405041$var$tracks = $669a8b47d2405041$var$player.audioTracks();
    $669a8b47d2405041$var$setupAudioTracks();
    $669a8b47d2405041$var$tracks.addEventListener("change", $669a8b47d2405041$var$trackChanged);
    $669a8b47d2405041$var$player.on("play", ()=>{
        $669a8b47d2405041$var$player.trigger("hideNotice");
        $669a8b47d2405041$var$player.tech_.on("retryplaylist", $669a8b47d2405041$var$playingStreamBrokeAway);
    });
    // we passed the initial play-function and should be allowed to play video.
    // problems happening now are video-server-based (stream/vod not avaliable, ...)
    // so let's retry with exponential delay capped to {maxRetryDelay} seconds
    $669a8b47d2405041$var$player.reloadSourceOnError({
        errorInterval: 1,
        getSource: function(reload) {
            if ($669a8b47d2405041$var$functionMaxRetryReached) return $669a8b47d2405041$var$player.error("ERR_MAX_FUNCTION_RETRIES_REACHED");
            $669a8b47d2405041$var$player.error(null); // hide error as we display the overlay
            $669a8b47d2405041$var$player.trigger("showNotice");
            const wait = Math.min($669a8b47d2405041$var$maxRetryDelay, 2 ** $669a8b47d2405041$var$errorCount);
            setTimeout(()=>reload({
                    src: $669a8b47d2405041$var$getCurrentStream().source.src,
                    type: $669a8b47d2405041$var$getCurrentStream().source.sourceType
                }), wait * 1000);
            $669a8b47d2405041$var$errorCount++;
            console.log(`Error #${$669a8b47d2405041$var$errorCount}, retrying in ${wait}s...`);
        }
    });
    $669a8b47d2405041$var$player.on("pause", ()=>{
        $669a8b47d2405041$var$releaseWakeLock();
    });
    $669a8b47d2405041$var$player.one("volumechange", ()=>{
        if (!$669a8b47d2405041$var$player.paused()) $669a8b47d2405041$var$requestWakeLock();
    });
    $669a8b47d2405041$var$player.one("playing", ()=>{
        $669a8b47d2405041$var$player.trigger("hidePoster");
        // Set overlay plugin for streams that are/were available
        $669a8b47d2405041$var$player.overlay({
            overlays: [
                {
                    ...(0, $b7eebcf7cc31128e$export$90f91d650d69eb98).afterStopNotice,
                    content: config.play.afterStopNotice || (0, $b7eebcf7cc31128e$export$90f91d650d69eb98).afterStopNotice.content
                }
            ]
        });
        (0, $f075168bfc01f057$export$2e2bcd8739ae039).sendPlayMediaEvent();
        $669a8b47d2405041$var$tracks.addEventListener("change", $669a8b47d2405041$var$trackTrackChange);
    });
    $669a8b47d2405041$var$player.on("playing", ()=>{
        $669a8b47d2405041$var$requestWakeLock();
        $669a8b47d2405041$var$player.trigger("hideNotice");
        if ($669a8b47d2405041$var$bufferEmptyTimeout) {
            clearTimeout($669a8b47d2405041$var$bufferEmptyTimeout);
            $669a8b47d2405041$var$bufferEmptyTimeout = null;
        }
        if ($669a8b47d2405041$var$wasMuted !== null) {
            $669a8b47d2405041$var$player.muted($669a8b47d2405041$var$wasMuted);
            $669a8b47d2405041$var$wasMuted = null;
        }
        $669a8b47d2405041$var$errorCount = 0;
    });
    $669a8b47d2405041$var$player.on("ended", (event)=>{
        $669a8b47d2405041$var$releaseWakeLock();
        (0, $f075168bfc01f057$export$2e2bcd8739ae039).sendMediaEvent(event.type);
    });
    $669a8b47d2405041$var$player.on("error", (event)=>{
        console.error("CAPTURED ERROR", event);
    });
    $669a8b47d2405041$var$tracks.trigger("change");
    (0, $f075168bfc01f057$export$2e2bcd8739ae039).sendViewEvent();
    window.p = $669a8b47d2405041$var$player;
    // if we're inside safari, video runs probably natively, so we need to register directly on the video tag
    if ((0, $azCq4.default).browser.IS_SAFARI) {
        let wasPlaying = false;
        const videoTag = document.querySelector('video');
        videoTag.addEventListener('ended', ()=>{
            $669a8b47d2405041$var$releaseWakeLock();
            console.log('Video has ended.');
            (0, $f075168bfc01f057$export$2e2bcd8739ae039).sendMediaEvent('ended');
        });
        videoTag.addEventListener('waiting', ()=>{
            $669a8b47d2405041$var$releaseWakeLock();
            console.log("Waiting for data\u2026"); // Indicates buffering
            $669a8b47d2405041$var$player.trigger("showNotice");
            if (wasPlaying && !$669a8b47d2405041$var$bufferEmptyTimeout) $669a8b47d2405041$var$bufferEmptyTimeout = setTimeout(()=>{
                $669a8b47d2405041$var$wasMuted = $669a8b47d2405041$var$player.muted();
                console.log('Buffering is taking too long, reloading the stream.');
                wasPlaying = false;
                $669a8b47d2405041$var$trackChanged();
            }, $669a8b47d2405041$var$forceReloadBufferEmptyMs); // we give it 15s to recover before reloading
        });
        videoTag.addEventListener('playing', ()=>{
            $669a8b47d2405041$var$requestWakeLock();
            console.log('Video is playing.');
            wasPlaying = true;
            $669a8b47d2405041$var$player.trigger("hideNotice");
            $669a8b47d2405041$var$player.overlay({
                overlays: [
                    {
                        ...(0, $b7eebcf7cc31128e$export$90f91d650d69eb98).afterStopNotice,
                        content: config.play.afterStopNotice || (0, $b7eebcf7cc31128e$export$90f91d650d69eb98).afterStopNotice.content
                    }
                ]
            });
            if ($669a8b47d2405041$var$bufferEmptyTimeout) {
                clearTimeout($669a8b47d2405041$var$bufferEmptyTimeout);
                $669a8b47d2405041$var$bufferEmptyTimeout = null;
            }
            if ($669a8b47d2405041$var$wasMuted !== null) {
                $669a8b47d2405041$var$player.muted($669a8b47d2405041$var$wasMuted);
                $669a8b47d2405041$var$wasMuted = null;
            }
        });
    }
}
$669a8b47d2405041$var$init();
function $669a8b47d2405041$var$requestWakeLock() {
    if ('wakeLock' in navigator && !$669a8b47d2405041$var$wakeLock) navigator.wakeLock.request('screen').then((wl)=>$669a8b47d2405041$var$wakeLock = wl).catch((err)=>{
        console.warn(`WakeLock request error: ${err.name}, ${err.message}`);
        $669a8b47d2405041$var$wakeLock = null;
    });
}
function $669a8b47d2405041$var$releaseWakeLock() {
    if ('wakeLock' in navigator && $669a8b47d2405041$var$wakeLock) $669a8b47d2405041$var$wakeLock.release().then(()=>$669a8b47d2405041$var$wakeLock = null).catch((err)=>{
        console.warn(`WakeLock release error: ${err.name}, ${err.message}`);
        $669a8b47d2405041$var$wakeLock = null;
    });
}


//# sourceMappingURL=play.1968905f.js.map
